import { RCS_QUEUING_NEUTRAL } from 'Api/beRcs'
import { atom } from 'recoil'

export const scheduledSendingState = atom({
  key: 'rec_IsScheduledSendingState',
  default: {
    isScheduledSending: false
  }
})

export const recipientsState = atom({
  key: 'rec_recipients',
  default: {
    totalRecipients: null,
    filetrRecipients: null,
    loadingRecipients: false
  }
})

export const progressState = atom({
  key: 'rcs_ProgressBarState',
  default: {
    startQueuing: false,
    loading: false,
    loaded: false,
    queueStatus: RCS_QUEUING_NEUTRAL,
    variant: 'neutral',
    toBeQueued: 0,
    queued: 0,
    queuedPercentage: 0,
    bandwidth: undefined,
    sendMethodType: undefined,
    estimatedSendingTime: undefined,
    cost: null
  }
})
